var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55.2328,30.1013 L37.8983,12.7665 C37.4035,12.2716 36.744,12 36.0407,12 C35.3368,12 34.6776,12.272 34.1828,12.7665 L32.609,14.3407 C32.1145,14.8347 31.8421,15.4946 31.8421,16.1982 C31.8421,16.9014 32.1145,17.5836 32.609,18.0776 L42.7217,28.2126 L10.5931,28.2126 C9.14458,28.2126 8,29.3466 8,30.7956 L8,33.0211 C8,34.4701 9.14458,35.7185 10.5931,35.7185 L42.8364,35.7185 L32.6094,45.91 C32.1149,46.4048 31.8425,47.0468 31.8425,47.7504 C31.8425,48.4532 32.1149,49.1045 32.6094,49.5989 L34.1832,51.1681 C34.678,51.6629 35.3371,51.9326 36.0411,51.9326 C36.7444,51.9326 37.4039,51.6594 37.8987,51.1646 L55.2332,33.8301 C55.7292,33.3337 56.0019,32.6711 56,31.9667 C56.0016,31.26 55.7292,30.5969 55.2328,30.1013 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.727669903f55f99c192b171503a89b80.svg";
export { ForwardRef as ReactComponent };